<div class="menu">
  <div class="menu--left-actions">
    <button *ngIf="menuItems.filters" mat-raised-button type="button" (click)="getFilters()"><mat-icon>filter_alt</mat-icon>Filtres</button>
    <button *ngIf="menuItems.myActivities" mat-raised-button type="button" (click)="goMyActivities()"><mat-icon>assignment</mat-icon>Mes inscriptions</button>
    <button *ngIf="menuItems.returnToActivities" mat-raised-button type="button" (click)="goActivitiesList()"><mat-icon>low_priority</mat-icon>Retour à la liste des activités</button>
  </div>
  <div class="menu--right-actions">
    <button mat-raised-button type="button" (click)="setTheme()"><mat-icon>palette</mat-icon></button>
    <button mat-raised-button type="button" (click)="setAccessibility()"><mat-icon>accessibility</mat-icon></button>
  </div>
</div>
